// extracted by mini-css-extract-plugin
export default {"form":"ViewContrato_form__Lcqxy","areaBtn":"ViewContrato_areaBtn__RQtPQ","btn":"ViewContrato_btn__lHAvV","btn2":"ViewContrato_btn2__ePTqN"};